<template>
  <div>
    <img src="" alt="" />
    <h1 class="bigTitle">在线健康问卷表</h1>
    <span class="description">
      &nbsp;&nbsp;&nbsp;&nbsp;这是难得的机会让我们检视身体状况，因为多数疾病的发生与日常生活及习惯是息息相关的，如有下列情况存在代表您的生活与营养摄入有调整的必要，请填写问卷我们将与您分享营养的资讯。
    </span>
    <div>
      <van-form @submit="onSubmit">
        <van-cell-group
          v-for="item in healthQuestionnaireList"
          :key="item.id"
          inset
        >
          <div class="healthQuestionnaContent">
            <span class="title">{{ item.title }}</span>
            <!-- 单选框 -->
            <van-field
              v-model="item.answer"
              v-if="item.type == 'input'"
              :name="item.title"
              :rules="[{ required: true, message: `请填写${item.title}` }]"
            />
            <!-- 多个单选框 -->
            <div v-if="item.type == 'inputMultiple'">
              <div v-for="input in item.inputList" :key="input.id">
                <van-field
                  v-model="input.answer"
                  :label="input.title"
                  :name="input.title"
                  :rules="[{ required: true, message: `请填写${item.title}` }]"
                />
              </div>
            </div>
            <!-- 多选框 -->
            <div
              v-if="item.type == 'checkbox'"
              style="margin-top: 10px; border: 1px solid #e3e3e3"
            >
              <div
                class="checkboxContent"
                v-for="question in item.questionList"
                :key="question.id"
              >
                <van-checkbox v-model="question.answer" shape="square" />
                <span>{{ question.title }}</span>
              </div>
            </div>

            <!-- 多个多选框 -->
            <div
              v-if="item.type == 'checkboxMultiple'"
              style="margin-top: 10px; border: 1px solid #e3e3e3"
            >
              <van-row
                style="
                  width: 100%;
                  padding: 10px 0;
                  border-bottom: 1px solid #e3e3e3;
                "
              >
                <van-col align="center" span="3"></van-col>
                <van-col align="center" span="7">有</van-col>
                <van-col align="center" span="7">无</van-col>
                <van-col align="center" span="7">偶尔</van-col>
              </van-row>
              <div
                class="checkboxMultipleContent"
                v-for="question in item.questionList"
                :key="question.id"
              >
                <van-row style="width: 100%">
                  <van-col align="center" span="3">
                    <span>{{ question.title }}</span>
                  </van-col>
                  <van-col
                    v-for="children in question.childrenQuestionList"
                    :key="children.id"
                    align="center"
                    span="7"
                  >
                    <van-checkbox v-model="children.answer" shape="square" />
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-cell-group>
        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { answerSave } from "@/api/shandayi";
import { useRoute } from "vue-router";
import { Notify } from "vant";
const route = useRoute();
const healthQuestionnaireList = ref([
  {
    id: 1,
    title: "姓名",
    type: "input",
    answer: "",
  },

  {
    id: 2,
    title: "胖瘦原因",
    type: "checkbox",
    answer: "",
    questionList: [
      {
        id: 21,
        title: "产后",
      },
      {
        id: 22,
        title: "遗传",
      },
    ],
  },
  {
    id: 3,
    title: "个人习惯调查【多选题】",
    type: "checkboxMultiple",
    questionList: [
      {
        id: 21,
        title: "喝茶",
        answer: "",
        childrenQuestionList: [
          {
            id: 211,
            title: "有",
            answer: "",
          },
          {
            id: 212,
            title: "无",
            answer: "",
          },
          {
            id: 213,
            title: "偶尔",
            answer: "",
          },
        ],
      },
      {
        id: 22,
        title: "遗传",
        childrenQuestionList: [
          {
            id: 211,
            title: "有",
            answer: "",
          },
          {
            id: 212,
            title: "无",
            answer: "",
          },
          {
            id: 213,
            title: "偶尔",
            answer: "",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    title: "一日三餐调查",
    type: "inputMultiple",
    tip: "有则填写，无则忽略",
    inputList: [
      {
        id: 41,
        title: "早餐时间",
        answer: "",
      },
      {
        id: 42,
        title: "午餐时间时间",
        answer: "",
      },
      {
        id: 43,
        title: "晚餐时间",
        answer: "",
      },
    ],
  },
  {
    id: 5,
    title: "日常作息调查",
    type: "inputMultiple",
    tip: "有则填写，无则忽略",
    inputList: [
      {
        id: 41,
        title: "早餐时间",
        answer: "",
      },
      {
        id: 42,
        title: "午餐时间时间",
        answer: "",
      },
      {
        id: 43,
        title: "晚餐时间",
        answer: "",
      },
    ],
  },
]);
// 问卷提交
const onSubmit = () => {
  const content = JSON.stringify(healthQuestionnaireList.value);
  const params = {
    content,
    patientId: route.query.p,
    id: route.query.i,
  };
  answerSave(params).then((v) => {
    console.log(v);
    Notify({ type: "success", message: `提交成功` });
  });
};
</script>
<style lang="scss" scoped>
h1 {
  color: #0095ff !important;
  text-align: center;
}
.description {
  display: inline-block;
  padding: 0 20px;
  line-height: 24px;
}
.van-form {
  padding: 10px;
  .healthQuestionnaContent {
    padding: 10px 0;
  }
  .van-cell {
    margin-top: 10px;
    align-items: center;
    ::v-deep .van-field__body {
      padding: 5px;
      border: 1px solid #e3e3e3;
    }
  }
  .checkboxContent {
    display: flex;
    padding: 10px;
    border-bottom: 1px solid #e3e3e3;
    span {
      margin-left: 10px;
    }
  }
  .checkboxMultipleContent {
    @extend .checkboxContent;
    .van-checkbox {
      display: inline-block;
    }
  }
}
</style>
